import axios from 'axios'
import { EXCLUIR_IMPOSTO_EMPRESA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirImpostoEmpresa (idImpostoEmpresa) {
  const url = `${URL}/imposto-empresa/${idImpostoEmpresa}/excluir`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_IMPOSTO_EMPRESA,
        payload: response

      })
  );
}
